import "./App.css";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router} from "react-router-dom";
import Approutes from "./routes/appRoutes";
import AuthWatcher from "./utils/authWatcher";

function App() {
  return (
    <>
     <Router>
      <AuthWatcher/>
      <Approutes/>
      <ToastContainer closeOnClick pauseOnHover draggable />
    </Router>
    </>
  );
}

export default App;
